import { render, staticRenderFns } from "./Crops.vue?vue&type=template&id=5916bd5c&scoped=true"
import script from "./Crops.vue?vue&type=script&lang=js"
export * from "./Crops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5916bd5c",
  null
  
)

export default component.exports